<template>
  <form enctype="multipart/form-data">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{subject_id ? 'Update' : 'Create'}} Subject</p>
      </header>
      <div class="modal-card-body">
        <!--Loading-->
        <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
        <b-field label="Name">
          <b-input
            v-model="subject.name"
            ref="title"
            minlength="3"
            required
            type="text"
            placeholder="Add subject name here"
          ></b-input>
        </b-field>
        <b-field label="Description">
          <b-input
            ref="message"
            minlength="3"
            v-model="subject.description"
            type="textarea"
            placeholder="Add subject description here"
          ></b-input>
        </b-field>
        <b-field label="Remarks">
          <b-input
            ref="message"
            minlength="3"
            v-model="subject.remarks"
            type="textarea"
            placeholder="Add any remarks"
          ></b-input>
        </b-field>
        <b-field label="Status">
          <b-switch
            ref="status"
            v-model="subject.status"
            type="is-success"
          >{{subject.status ? 'Active' : 'Non-Active'}}</b-switch>
        </b-field>
        <!-- <div class="tags">
          <span
            v-for="(file_obj, edit_file_index) in editfiles"
            :key="`EDIT_FILE_${edit_file_index}`"
          >
            <span style="margin: 0 5px;" class="tag is-primary" v-if="!file_obj.is_deleted">
              {{$common.fileBasename(file_obj.name)}}
              <button
                class="delete is-small"
                type="button"
                @click="deleteExistingFile(edit_file_index)"
              ></button>
            </span>
          </span>
        </div> -->
        <!-- <b-field class="file">
          <b-upload v-model="announcementfiles" multiple>
            <a class="button is-dark">
              <b-icon icon="upload"></b-icon>
              <span>Add Files</span>
            </a>
          </b-upload>
          <span
            class="file-name"
            v-for="(file, file_index) in announcementfiles"
            :key="file_index"
          >{{file.name}}</span>
        </b-field> -->
        <button
          type="button"
          @click.prevent="proceed()"
          class="button is-success btn-center"
        >{{subject_id ? 'Update' : 'Create'}}</button>
      </div>
    </div>
  </form>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "set-subject",
  data() {
    return {
      // announcementfiles: null,
      isLoading: false,
      subject : {
        name: "",
        description: "",
        remarks : "",
        status : true
        // editfiles: [],
      }
    };
  },
  props: {
    subject_id: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapGetters(["getTeacherToken", "fetchCurrentSubject"]),
  },
  methods: {
    ...mapActions([
      "createSubject",
      "updateSubject",
      "loadSubjectDetails",
    ]),
    deleteExistingFile(index) {
      this.editfiles[index].is_deleted = true;
    },
    proceed() {
      let is_validate = this.$refs.title.checkHtml5Validity() && this.$refs.message.checkHtml5Validity();
      if (is_validate) {
        this.isLoading = true;
        if (this.subject_id) {
          //For editing a subject
          this.updateSubject({
            subject_id: this.subject_id,
            subject: this.subject,
            token: this.getTeacherToken,
          })
          .then(() => {
            this.isLoading = false;
            this.$emit("over");
            this.$buefy.toast.open({
              message: "Subject updated successfully",
              type: "is-success",
            });
          })
          .catch((err) => {
            this.isLoading = false;
            this.$emit("over");
            console.log(err)
            this.$buefy.toast.open({
              message: err.response.data,
              type: "is-danger",
            });
          });
        } else {
          //For creating a new subject
          this.createSubject({
            subject: this.subject,
            token: this.getTeacherToken,
          })
          .then(() => {
            this.isLoading = false;
            this.$emit("over");
            this.$buefy.toast.open({
              message: "Subject created successfully",
              type: "is-success",
            });
          })
          .catch((err) => {
            this.isLoading = false;
            this.$emit("over");
            this.$buefy.toast.open({
              message: err.response.data,
              type: "is-danger",
            });
          });
        }
      }
    },
  },
  async created() {
    if (this.subject_id) {
      this.isLoading = true;
      await this.loadSubjectDetails({
        subject: this.subject_id,
        token: this.getTeacherToken,
      });

      for(let key in this.subject){
        this.subject[key] = this.fetchCurrentSubject[key]
      }
      // this.editfiles = this.fetchCurrentSubject.files.map((file_name) => {
      //   return {
      //     name: this.$common.fileBasename(file_name),
      //     is_deleted: false,
      //   }
      // })
      this.isLoading = false;
    }
  },
};
</script>
<style scoped>
</style>